import { FormStatusTab } from '../types';
import type { FormDetailStatus } from './types';

export function toFormDetailDisplayStatus(
  status: string | null | undefined,
): FormDetailStatus {
  switch (status?.toLowerCase()) {
    case 'active':
      return 'Published';
    case 'inactive':
      return 'Unpublished';
    case 'archived':
      return 'Archived';
    default:
      return 'Draft';
  }
}

export function mapQuestionnaireStatusToFormStatusTab(
  status: string | null | undefined,
): FormStatusTab {
  switch (status?.toLowerCase()) {
    case 'active':
      return FormStatusTab.ACTIVE;
    case 'inactive':
      return FormStatusTab.UNPUBLISHED;
    case 'archived':
      return FormStatusTab.ARCHIVED;
    default:
      return FormStatusTab.DRAFTS;
  }
}
